import {motion} from 'framer-motion';
import React from 'react';

import SuraLogo from '../../../../assets/svgs/SuraLogo';
import Icons from '../../../../assets/svgs/icons';

const titles = [
  'Mobi Sura',
  'Dados do cliente',
  'Equipamentos',
  'Dados da bicicleta',
  'Coberturas',
  'Coberturas escolhidas',
  'Dados',
  'Envio de links',
];
const titlesSegurado = ['Resumo', 'Informações da Bike', 'Confirme as informações'];

const titlesModal = [
  'Mobi Sura',
  'Dados do cliente',
  'Equipamentos',
  'Dados do equipamento',
  'Coberturas',
  'Coberturas escolhidas',
  'Dados',
  'Envio de links',
];
const titlesSeguradoModal = ['Resumo', 'Informações do equipamento', 'Confirme as informações'];

const Header = ({current, isSegurado, logoParceiro, isModal, corPrimaria, token}) => {
  const temp = isSegurado ? new Array(3).fill(0) : new Array(8).fill(0);

  const variants = {
    a: {width: '100%'},
    b: {width: '0'},
  };

  return (
    <header className="uniqueHeader">
      <div className="headerLogo d-flex align-items-center">
        <div>
          <SuraLogo height="50px" />
        </div>

        {!!logoParceiro && <img src={logoParceiro} alt="Logo parceiro" />}
      </div>

      {token && (
        <a
          href={'https://admin.bikeinspec.com.br/user/login_sura' + '?t=' + token?.substring(7, token?.length)}
          target="_blank"
          rel="noopener noreferrer">
          <Icons name={'bill'} size="5%" className="mr-2" /> Acompanhar minhas cotações
        </a>
      )}

      <div className="stepsByStep">
        {!isModal ? (
          <span style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>
            Etapa {current + 1}: {isSegurado ? titlesSegurado[current] : titles[current]}
          </span>
        ) : (
          <span style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>
            Etapa {current + 1}: {isSegurado ? titlesSeguradoModal[current] : titlesModal[current]}
          </span>
        )}

        <div className="stepsIndicators">
          {temp.map((_, index) => (
            <div key={'c' + index} className="lineStepIndicator">
              <motion.div animate={current >= index ? 'a' : 'b'} className="activateStep" variants={variants} />
            </div>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;
